module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/5@2x_ef5824b6826626f2a1eee10c01ce50f0.png";